import React from 'react';
import styles from './EmptyWidget.module.css';

type EmptyWidgetProps = {
    title?: string;
    message?: string;
    imgUrl?: string;
};

function EmptyWidget({
    title = 'Nothing under the hood',
    message = 'Data will appear here once it’s available.',
    imgUrl = '',
}: EmptyWidgetProps) {
    return (
        <div className={styles.emptyWidget}>
            {imgUrl && <img src={imgUrl} alt="Empty Widget" />}
            <h4>{title}</h4>
            <p>{message}</p>
        </div>
    );
}

export default EmptyWidget;
